module.exports = __webpack_public_path__ + "static/media/hotel-villa-antonio-orebic-double-room-cover.24558000.jpg";